export function sortCardsByIds<T extends { id: string }>(cards: Array<T>, ids: string[]) {
  const sortedCards = [...cards].sort((a, b) => ids.indexOf(a.id) - ids.indexOf(b.id));
  return sortedCards;
}
